import {
  Calendar,
  Package,
  CheckCircle,
  X,
  Circle,
} from '@spcc/uikit'
import type { ShipmentStatus } from '../../../domain/types'

export type StatusConfig = {
  bg: string
  text: string
  icon: typeof Calendar
  gradient: string
  dotColor: string
}

export const defaultStatusConfig: StatusConfig = {
  bg: 'bg-gray-50 dark:bg-gray-500/10',
  text: 'text-gray-700 dark:text-gray-400',
  icon: Circle,
  gradient: 'from-gray-500 to-gray-600',
  dotColor: 'bg-gray-500',
}

export const statusConfig: Record<ShipmentStatus, StatusConfig> = {
  scheduled: {
    bg: 'bg-slate-50 dark:bg-slate-500/10',
    text: 'text-slate-700 dark:text-slate-400',
    icon: Calendar,
    gradient: 'from-slate-500 to-slate-600',
    dotColor: 'bg-slate-500',
  },
  loading: {
    bg: 'bg-amber-50 dark:bg-amber-500/10',
    text: 'text-amber-700 dark:text-amber-400',
    icon: Package,
    gradient: 'from-amber-500 to-orange-500',
    dotColor: 'bg-amber-500',
  },
  delivered: {
    bg: 'bg-emerald-50 dark:bg-emerald-500/10',
    text: 'text-emerald-700 dark:text-emerald-400',
    icon: CheckCircle,
    gradient: 'from-emerald-500 to-emerald-600',
    dotColor: 'bg-emerald-500',
  },
  cancelled: {
    bg: 'bg-red-50 dark:bg-red-500/10',
    text: 'text-red-700 dark:text-red-400',
    icon: X,
    gradient: 'from-red-500 to-red-600',
    dotColor: 'bg-red-500',
  },
}
